export enum ScopeLevel {
  Campaign = 'campaign',
  AdGroup = 'adgroup',
}
